import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveDigitalPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export const humidityGlobalCodes = new Map<string, string>();
export const humidityHelperCode = `float _sbeGetHumidity(DHT& dht) {\n  float humidity = dht.readHumidity();\n  return isnan(humidity) ? NAN : humidity;\n}\n`;

let _used = false;

export function humidityUsed(): boolean {
    return _used;
}

export function resetHumidity(): void {
    _used = false;
    humidityGlobalCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['humidity'] = function (block: Blockly.Block): [string, number] {
        const pin = resolveDigitalPin(block);
        const varName = `_dht_${pin}`;

        humidityGlobalCodes.set(pin, `DHT ${varName}(${pin}, DHT_MODEL);\n`);

        if (!_used) {
            registerSetupCode('humidity_delay', `  delay(2000);\n`);
        }
        registerSetupCode(pin, `  ${varName}.begin();\n`);

        _used = true;
        return expr(`_sbeGetHumidity(${varName})`);
    };
}
